/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

/** 
	À décommenter et modifier pour activer un chargement entre les changements de page
	fonctions : showLoader / hideLoader à compléter
	Defaut : false
**/
// pageTransition = true;

/** 
	À décommenter et modifier pour activer le chargement des pages en ajax
	Defaut : false
	Note : les liens qui font appel à un chargement via AJAX doivent contenir l'attribut rel="address"
**/
pageAjax = true;

/** 
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir des tablettes (768)
**/
// parallaxBreakpoint = 768;

jQuery(document).ready(function() {
	// jQuery('.container-logo-home img').animate({"opacity": "1", "height":"700px", "width":"467px"},5000);
});


(function($) {


	/*
	########   ########    ######    ####  ########   ########   
	##     ##  ##         ##    ##    ##        ##    ##         
	##     ##  ##         ##          ##       ##     ##         
	########   ######      ######     ##      ##      ######     
	##   ##    ##               ##    ##     ##       ##         
	##    ##   ##         ##    ##    ##    ##        ##         
	##     ##  ########    ######    ####  ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/

	/* Fonctions exécutées à chaque resize */
	var resizeHandler = function() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();
		
		/* Autres fonctions jouées au resize */
		// resizeSlider();
		// resizeNav();
	};

	
	/*
	 ######     ######    ########    #######   ##         ##         
	##    ##   ##    ##   ##     ##  ##     ##  ##         ##         
	##         ##         ##     ##  ##     ##  ##         ##         
	 ######    ##         ########   ##     ##  ##         ##         
	      ##   ##         ##   ##    ##     ##  ##         ##         
	##    ##   ##    ##   ##    ##   ##     ##  ##         ##         
	 ######     ######    ##     ##   #######   ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/
	/* Fonctions exécutées au scroll */
	var scrollHandler = function() {
		var scrollTop = $(window).scrollTop();
		
		// /* EXEMPLE */
		// if (scrollTop > 380) {
		// 	$('.header').addClass('prestuck');
		// }
		// else {
		// 	$('.header').removeClass('prestuck');
		// }
	};


	

	/*
	##          #######      ###     ########   ########   ########   
	##         ##     ##    ## ##    ##     ##  ##         ##     ##  
	##         ##     ##   ##   ##   ##     ##  ##         ##     ##  
	##         ##     ##  ##     ##  ##     ##  ######     ########   
	##         ##     ##  #########  ##     ##  ##         ##   ##    
	##         ##     ##  ##     ##  ##     ##  ##         ##    ##   
	########    #######   ##     ##  ########   ########   ##     ##  
	*/

	showLoader = function(url) {
		tl = new TimelineLite();
		tl.pause();
		tl.add([
			TweenMax.fromTo( '.loader-pan.pan2', 1.5, { transformOrigin:'left 0', scaleX: 0 }, { scaleX: 1, ease:Power4.easeOut } ),
			TweenMax.fromTo( '.loader-pan.pan1', 1.5, { transformOrigin:'left 0', scaleX: 0 }, { scaleX: 1, ease:Power4.easeOut, delay: 0.15 } ),
			TweenMax.fromTo( '.loader-pan-img img', 0.5, { opacity: 0 }, { opacity: 1, delay: 0.6 } )
		]);
		tl.call(function() {
			// A la fin de l'anim, on redirige vers la nouvelle URLs
			
			$('.btn-open').removeClass('visible');
			$('.btn-close').removeClass('visible');
			$('.nav-main').removeClass('menu-open');
			$('.the-body').removeClass('noscroll');

			$(window).scrollTop(0);

			if( !pageAjax ){
				window.location.href = url;
			}else{
				// ajaxUrl.perform_ajax_request( url );
				showLoaderProgressing  = false;
			}
		});
		tl.play();
	};

	hideLoader = function() {
		// On lance l'animation de révélation de la page
		tl = new TimelineLite();
		tl.pause();
		tl.add([
			TweenMax.fromTo( '.loader-pan-img img', 0.5, { opacity: 1 }, { opacity: 0, delay: 0.2 } ),
			TweenMax.fromTo( '.loader-pan.pan1', 1.5, { transformOrigin:'right 0', scaleX: 1 }, { scaleX: 0, ease:Power4.easeOut, delay: 0.5 } ),
			TweenMax.fromTo( '.loader-pan.pan2', 1.5, { transformOrigin:'right 0', scaleX: 1 }, { scaleX: 0, ease:Power4.easeOut, delay: 0.65 } )

		]);	
		tl.call(function() {
			initScrollAnimations();
		}, [], this, 1);
		tl.play();
	};

	/*	Ajout d'un loader sur le chargement initial d’une page 
		Uniquement si la fonction de transition de page est active 
	*/
	if ( pageTransition ) {
		$('body').imagesLoaded( { background: true })
		.always( function(instance) {
			hideLoader();
		});
	}

	/*
	####  ##    ##   ####  ########   
	 ##   ###   ##    ##      ##      
	 ##   ####  ##    ##      ##      
	 ##   ## ## ##    ##      ##      
	 ##   ##  ####    ##      ##      
	 ##   ##   ###    ##      ##      
	####  ##    ##   ####     ##      
	*/

	// Charge la function permettant de gérer le chargement des pages via AJAX
	if( pageAjax ){
		ajaxUrl.init();
	}

	pageInit = function() {

		/*
		 ######     #######    #######   ##    ##   ####  ########   
		##    ##   ##     ##  ##     ##  ##   ##     ##   ##         
		##         ##     ##  ##     ##  ##  ##      ##   ##         
		##         ##     ##  ##     ##  #####       ##   ######     
		##         ##     ##  ##     ##  ##  ##      ##   ##         
		##    ##   ##     ##  ##     ##  ##   ##     ##   ##         
		 ######     #######    #######   ##    ##   ####  ########   
		*/
		
		switch( $('html').attr('lang') ){

			case "fr-FR":
				cookieText = "Nous diffusons des cookies afin d’analyser le trafic sur ce site. Les informations concernant l’utilisation que vous faites de notre site nous sont transmises dans cette optique.";
				acceptText = "J'accepte";
				break;

			default:
				cookieText = "We distribute cookies to analyze the traffic on this site. The information concerning the use you make of our site is transmitted to us in this perspective.";
				acceptText = "I accept";
				break;

		}

		$.cookieBar({
			message:       cookieText,
			acceptText:    acceptText,
			declineButton: false,
			expireDays:    30,
			fixed:         true,
			zindex:        10000
		});

		if(jQuery.cookieBar('cookies')){
			//Google Analytics or other code here
		}

		// Déclaration des évènements
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler);
		$('body').on('reveal', '.sr', scrollRevealHandler);
		
		// $(window).trigger('resize'); // Joue la fonction resizeHandler()
		formLoader();                // Affiche un 'cache' à la validation d’un form CF7

		/* Autres scripts qui doivent être initialisés */
		// slider.init();

		$('.data-mh').matchHeight();

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll( {
				hash: true
			});
			$.localScroll.hash();
		}

		// Fitvids = video embed responsive
		if ($('.fitvids').length > 0) {
			$('.fitvids').fitVids();
		}

		// Transmission des liens vers la fonction linkHandler()
		$('[data-link]').on('click', function(e) {
			linkHandler( $(this) );
		}).find('a').on('click', function(e) {
			e.stopPropagation();
		});

		$('a').on('click', function(e) {
			e.preventDefault();
			if( ! $(this).hasClass('cb-enable') ){ // fix click cookie bar
				linkHandler( $(this) );
			}
		});
	};

	afterAjax = function(){

		$('.data-mh').matchHeight();
		resizeParallax();

		$('.current-menu-item, .current-menu-parent').removeClass('current-menu-item').removeClass('current-menu-parent').removeClass('current-menu-item--active');
		$('a[href="'+ window.location.pathname +'"]').closest('li').addClass('current-menu-item');
		$('a[href="'+ window.location.pathname +'"]').closest('li.menu-item--lev1').addClass('current-menu-parent');

	};

	// Initialisation de toutes les fonctions utiles au chargement de la page
	pageInit();

	// Exemple d'utilisation du plugin Mcube Gmaps
	// $('.map').mcubeGmaps({
		// bounds:  false, // default : true
		// overlay: false, // default : true
		// styles:  [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]
	// });


		/*
	 ######    ##     ##     ###     ########   ########    ######         ##      ##  #######    #######   ########   
	##    ##   ##     ##    ## ##    ##     ##  ##         ##    ##        ##  ##  ## ##     ##  ##     ##  ##     ##  
	##         ##     ##   ##   ##   ##     ##  ##         ##              ##  ##  ## ##     ##  ##     ##  ##     ##  
	 ######    #########  ##     ##  ########   ######      ######         ##  ##  ## ##     ##  ##     ##  ##     ##  
	      ##   ##     ##  #########  ##         ##               ##        ##  ##  ## ##     ##  ##     ##  ##     ##  
	##    ##   ##     ##  ##     ##  ##         ##         ##    ##        ##  ##  ## ##     ##  ##     ##  ##     ##  
	 ######    ##     ##  ##     ##  ##         ########    ######          ###  ###   #######    #######   ########   
	*/



	function AnimateRotate(angle,repeat) {
	    var duration= 53000;
	    setTimeout(function() {
	        if(repeat && repeat == "infinite") {
	            AnimateRotate(angle,repeat);
	        } else if ( repeat && repeat > 1) {
	            AnimateRotate(angle, repeat-1);
	        }
	    },duration);   
	    var $elem = $('.shape');

	    $({deg: 0}).animate({deg: angle}, {
	        duration: duration,
	        step: function(now) {
	            $elem.css({
	                'transform': 'translateX(-50%) rotate('+ now +'deg)'
	            });
	        }
	    });
	}
	AnimateRotate(360,"infinite");


	function AnimateRotate2(angle,repeat) {
	    var duration= 47500;
	    setTimeout(function() {
	        if(repeat && repeat == "infinite") {
	            AnimateRotate2(angle,repeat);
	        } else if ( repeat && repeat > 1) {
	            AnimateRotate2(angle, repeat-1);
	        }
	    },duration);    
	    var $elem = $('.shape2');

	    $({deg: 0}).animate({deg: angle}, {
	        duration: duration,
	        step: function(now) {
	            $elem.css({
	                'transform': 'translateX(-50%) rotate('+ now +'deg)'
	            });
	        }
	    });
	}
	AnimateRotate2(-360,"infinite");



	function AnimateRotate3(angle,repeat) {
	    var duration= 45000;
	    setTimeout(function() {
	        if(repeat && repeat == "infinite") {
	            AnimateRotate3(angle,repeat);
	        } else if ( repeat && repeat > 1) {
	            AnimateRotate3(angle, repeat-1);
	        }
	    },duration);   
	    var $elem = $('.shape3');

	    $({deg: 0}).animate({deg: angle}, {
	        duration: duration,
	        step: function(now) {
	            $elem.css({
	                'transform': 'translateX(-50%) rotate('+ now +'deg)'
	            });
	        }
	    });
	}
	AnimateRotate3(360,"infinite");



	function AnimateRotate4(angle,repeat) {
	    var duration= 50000;
	    setTimeout(function() {
	        if(repeat && repeat == "infinite") {
	            AnimateRotate4(angle,repeat);
	        } else if ( repeat && repeat > 1) {
	            AnimateRotate4(angle, repeat-1);
	        }
	    },duration);    
	    var $elem = $('.shape4');

	    $({deg: 0}).animate({deg: angle}, {
	        duration: duration,
	        step: function(now) {
	            $elem.css({
	                'transform': 'translateX(-50%) rotate('+ now +'deg)'
	            });
	        }
	    });
	}
	AnimateRotate4(-360,"infinite");



		/*
	   ###     ##    ##   ####  ##     ##   ######    
	  ## ##    ###   ##    ##   ###   ###  ##    ##   
	 ##   ##   ####  ##    ##   #### ####  ##         
	##     ##  ## ## ##    ##   ## ### ##   ######    
	#########  ##  ####    ##   ##     ##        ##   
	##     ##  ##   ###    ##   ##     ##  ##    ##   
	##     ##  ##    ##   ####  ##     ##   ######    
	*/

	$(".btn-mobile").click(
		function() {
			$('.btn-open').toggleClass('visible');
			$('.btn-close').toggleClass('visible');
			$('.nav-main').toggleClass('menu-open');
			$('.the-body').toggleClass('noscroll');
			$('.current-menu-item').toggleClass('current-menu-item--active');
		}
	);


	$(".block-rea-listing").click(
		function() {
			$('.the-body').toggleClass('noscroll');
		}
	);


})(jQuery);
